#import "~/graphql/fragments/Components/CraftLink.graphql"
fragment CarousselBlock on carousselBlockBlock_Entry {
    title: blockTitle
    description
    backgroundColor
    carousselItems {
        
            __typename
            ... on imageItem_Entry {
                image {
                    url
                    width
                    height
                    w1200: url @transform(width: 1200, format: "webp")
                    w606: url @transform(width: 606, format: "webp")
                    w328: url @transform(width: 328, format: "webp")
                    w1200_avif: url @transform(width: 1200, format: "avif")
                    w606_avif: url @transform(width: 606, format: "avif")
                    w328_avif: url @transform(width: 328, format: "avif")
                }
            }
            ... on textItem_Entry {
                text
            }
            ... on textItemLink_Entry {
                text
                linkField {
                    ...CraftLinkField
                }
            }
        
    }
}
